export default __webpack_public_path__ + "static/media/no_network.2a71e121.svg";